// extracted by mini-css-extract-plugin
export var cardWrapper = "_52-0";